import angular from 'angular';

import DateModalComponent from './date-modal.cmpt';

export default angular
    .module('application.component.modals.component.date-modal', [])
    .component(DateModalComponent.selector, DateModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/date-modal/index.js